import { Body, Box, Card, Icon } from '..'
import { backgroundColors, cardRotations } from '../../../utilities.js'

export const SelectableList = ({ list, value, onChange }) => (
   <Box column fullWidth>
    {list.map((item, index) => (
      <Box key={index} justifyContent="space-between" pr={2} pb={2}>
        <Box
          width={32}
          ml={16}
          justifyContent="center"
          alignItems="center"
          style={{
            borderLeft: index === value ? 'solid 2px white' : 'solid 2px var(--grey)'
          }}
        >
          {(index === value) && <Box background="white" radius="50%" p={4} mr={32}>
            <Icon icon="Tick" fill="black" size={24}/>
          </Box>}
        </Box>
        <Card
          selected={index === value}
          onClick={() => onChange(index)}
          className={backgroundColors[index % backgroundColors.length]}
          transform={`rotate(${index === value ? 0 : cardRotations[index % cardRotations.length]}deg)`}
          justifyContent="start"
          minHeight={86}
          p={24}
          shadow={false}
          border={false}
          zIndex={(index === value) && 1}
        >
          <Box justifyContent="start" alignItems="center" fullWidth>
            <Body bold alt>{item}</Body>
          </Box>
        </Card>
      </Box>
    ))}
  </Box>
)